import styled from 'styled-components';

import { Contact } from 'components/Footer/Contact';
import { Socials } from 'components/Footer/Socials';
import { getCleanUrl } from 'helpers/url';
import { useAppSelector } from 'hooks/redux';
import { getEffectiveBgColor, isRgbColorDark } from 'helpers/colors';

interface ILogoProps {
  url: string;
  logoUrl?: string;
}

const Logo: React.FC<ILogoProps> = ({ logoUrl, url }) => {
  if (!logoUrl) return null;

  const handleClick = () => window.open(getCleanUrl(url), '_blank');

  return (
    <div onClick={handleClick} className="cursor-pointer">
      <a href={getCleanUrl(url)} target="_blank" rel="noreferrer" style={{ pointerEvents: 'none' }}>
        <div id="footer-logo-photographer" className="footer-logo mx-auto text-center">
          <img alt="logo" src={logoUrl} />
        </div>
      </a>
    </div>
  );
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: space-around;
  padding-left: 30px;
  padding-right: 30px;
`;

export const Footer: React.FC = () => {
  const userBrands = useAppSelector((state) => state.userBrand);
  const { logo, logoLight } = userBrands;

  const element = document.getElementById('footer-logo-photographer');
  const effectiveBgColor = getEffectiveBgColor(element);

  const isDarkBg = isRgbColorDark(effectiveBgColor);

  const logoUrl = isDarkBg && logoLight?.url ? logoLight?.url : logo?.url;

  const isSocialsPresent = (): boolean => {
    const { socials } = userBrands;

    const keys = Object.keys(socials);

    return keys.some((key) => socials[key] !== '');
  };

  return (
    <Wrapper data-cy="footer">
      <Logo logoUrl={logoUrl} url={userBrands.website} />
      <Contact />
      {isSocialsPresent() && <Socials />}
    </Wrapper>
  );
};
